"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIE11 = exports.hasStringTagBug = void 0;
var _setup = require("./_setup.js");
var _hasObjectTag = _interopRequireDefault(require("./_hasObjectTag.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
// In IE 11, the most common among them, this problem also applies to
// `Map`, `WeakMap` and `Set`.
var hasStringTagBug = exports.hasStringTagBug = _setup.supportsDataView && (0, _hasObjectTag.default)(new DataView(new ArrayBuffer(8))),
  isIE11 = exports.isIE11 = typeof Map !== 'undefined' && (0, _hasObjectTag.default)(new Map());